module.exports = require('./lib/keyword_extractor');


/*****************
 ** WEBPACK FOOTER
 ** ./~/keyword-extractor/index.js
 ** module id = 2977
 ** module chunks = 0
 **/